// @flow

import _ from "lodash";
import React, { Component } from "react";
import "./App.css";
import Hls from "hls.js";
import queryString from "query-string";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import { withStyles } from "@material-ui/core/styles";

import { Adease } from "adease-sdk";

import AdInject from "../AdInject/index";
import Beaconing from "../Beaconing/index";
import AdInfo from "../AdInfo/index";
import Typography from "@material-ui/core/Typography";

import logo from "../ad_ease_white.png";

const styles = theme => ({
  root: {},
  gridLeft: {
    paddingTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit
  },
  gridRight: {
    paddingTop: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginBottom: "100px"
  },
  icon: {
    marginLeft: theme.spacing.unit,
    width: theme.typography.fontSize
  },
  moreInfoButton: {
    marginBottom: theme.spacing.unit
  },
  card: {
    marginBottom: theme.spacing.unit
  },
  logoImage: {
    height: "1.9em",
    marginRight: theme.spacing.unit
  },
  appBar: {
    boxShadow: "none",
    backgroundColor: "#444",
    color: "white"
  },
  footer: {
    backgroundColor: "#444",
    bottom: 0,
    top: "unset"
  },
  toolbarFooter: {
    justifyContent: "space-between"
  },
  footerLogo: {
    height: "1.9em"
  }
});

const pointInTimeEvents = [
  "impression",
  "start",
  "firstQuartile",
  "midpoint",
  "thirdQuartile",
  "complete"
];

const AssetID = "1953300";

export type Beacon = {
  trackingURL: string,
  kind: string,
  sent: boolean,
  startTime: number,
  endTime: number
};

type Props = {
  classes: any
};

type adInfoT = {
  adDuration: number,
  adVendor: string,
  adTag: string
};

type State = {
  beacons: Array<Beacon>,
  // If this is non-empty, it means the player is showing an ad.
  clickthrough: string,
  waitingForAd: boolean,
  adInfo: adInfoT
};

class App extends Component<Props, State> {
  btnAdInjectTimeout: any;
  manifestURL: string;
  initPlayback: Function;
  initialiseHLSMode: Function;
  initialiseVanilaMode: Function;
  videoElementAdded: Function;
  adBreakRequested: Function;
  getElementalImage: Function;
  sendAdInjectionSignal: Function;
  debug: boolean;
  video: HTMLVideoElement;

  useImage: boolean = false;
  category: string = "all";
  configURL: string;
  elementalHost: string;
  serverHost: string;
  adease: Adease;

  constructor(props: Props) {
    super(props);

    this.state = {
      beacons: [],
      clickthrough: "",
      waitingForAd: true,
      adInfo: {
        adDuration: 0,
        adTag: "",
        adVendor: ""
      }
    };

    this.btnAdInjectTimeout = undefined;
    this.manifestURL = "";

    const serverHost = process.env.REACT_APP_API_ADDRESS || "http://localhost";
    this.serverHost = serverHost;
    const elementalHost =
      process.env.REACT_APP_STREAM_ADDRESS ||
      "https://stsymbal.switchmedia.asia";
    this.elementalHost = elementalHost;

    const qs = queryString.parse(queryString.extract(window.location.href));
    const qsKeys = Object.keys(qs);
    this.useImage = qsKeys.includes("useImage");
    if (qsKeys.includes("category")) {
      this.category = qs["category"] || this.category;
    }

    const subs = "[CATEGORY]:" + this.category;
    const configQuery = queryString.stringify({
      subs: subs,
      videoID: AssetID
    });

    this.configURL = [
      this.serverHost,
      "282",
      "playback",
      "getUniversalPlayerConfig?" + configQuery
    ].join("/");

    this.adease = new Adease(serverHost, {});

    this.initPlayback = this.initPlayback.bind(this);
    this.initialiseHLSMode = this.initialiseHLSMode.bind(this);
    this.initialiseVanilaMode = this.initialiseVanilaMode.bind(this);
    this.adBreakRequested = this.adBreakRequested.bind(this);
    this.videoElementAdded = this.videoElementAdded.bind(this);
    this.sendAdInjectionSignal = this.sendAdInjectionSignal.bind(this);
    this.getElementalImage = this.getElementalImage.bind(this);
  }

  mergeState(newState: any): void {
    this.setState(state => Object.assign({}, state, newState));
  }

  videoElementAdded(el) {
    this.video = el;

    let sessionID = "";
    fetch(this.configURL)
      .then(resp => resp.json())
      .then(json => {
        sessionID = json.sessionID;
        return json;
      })
      .then(json => {
        this.adease = new Adease(this.serverHost, {
          sessionID: sessionID,
          assetID: AssetID
        });
        this.adease.configureFromObject(json);
      })
      .then(() => this.adease.getStreams())
      .then(_.first)
      .then(stream => stream.url)
      .then(this.initPlayback)
      .then(() => {
        el.addEventListener("timeupdate", e =>
          this.adease.notifyTimeUpdate(el.currentTime * 1000)
        );
      });
  }

  attachAdDataHandler(adID: string) {
    const qs = queryString.parse(queryString.extract(window.location.href));
    const debug = qs.debug !== undefined;

    this.debug = debug;

    const ad = _.first(this.adease.getAds().filter(ad => ad.id === adID));
    if (!ad) {
      console.warn("ad wanted is not available in adease sdk");
      return;
    }
    const beacons = ad.trackingUrls
      .map(beacon => ({ ...beacon, sent: false }))
      .toJS();

    this.mergeState({
      waitingForAd: false,
      beacons: beacons
    });

    const adDuration = (ad.endTime - ad.startTime) / 1000;

    const getAdVendor = (adUniqueID: string): string => {
      return adUniqueID.split("-")[0];
    };

    this.setState(state => ({
      ...state,
      adInfo: {
        ...state.adInfo,
        adDuration: Math.round(adDuration),
        adVendor: getAdVendor(adID)
      }
    }));

    const progressFn = _.throttle((evt: Event) => {
      if (this.video.currentTime >= ad.startTime / 1000) {
        const adOffset = this.video.currentTime - ad.startTime / 1000;
        console.log("SEND BEACONS NOW", adOffset);

        const newBeacons = this.state.beacons.map((beacon: Beacon): Beacon => {
          if (
            pointInTimeEvents.includes(beacon.kind) &&
            !beacon.sent &&
            this.video.currentTime >= beacon.startTime / 1000
          ) {
            // fetch(beacon.trackingURL);
            return Object.assign({}, beacon, {
              sent: true
            });
          }

          return beacon;
        });
        this.mergeState({
          beacons: newBeacons
        });

        if (adOffset >= adDuration) {
          console.log("ad finished");
          this.video.removeEventListener("timeupdate", progressFn);
          // Disable ad mode
          this.mergeState({
            clickthrough: ""
          });
        }
      }
    }, 200);
    this.video.addEventListener("timeupdate", progressFn);
  }

  initPlayback(url: string) {
    if (url === "") {
      console.warn("Manifest URL is empty");
      return;
    }
    if (Hls.isSupported()) {
      this.initialiseHLSMode(url);
    } else {
      console.info("Using native HLS support");
      this.initialiseVanilaMode(url);
    }
  }

  initialiseVanilaMode(url: string) {
    this.video.src = url;

    this.video.textTracks.addEventListener("addtrack", (addTrackEvent: any) => {
      const trackList: TextTrackList = this.video.textTracks;
      const track = _.first(
        _.filter(trackList, track => track.kind === "metadata")
      );
      if (!track) {
        return;
      }
      track.mode = "hidden";

      track.addEventListener("cuechange", (cueChangeEvent: any) => {
        const buf = cueChangeEvent.target.activeCues[0].value.data;
        const dec = new TextDecoder("utf-8");
        dec.decode(buf);
      });
    });

    if (this.debug) {
      let listenFor = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted ",
        "ended",
        "error",
        "interruptbegin",
        "interruptend",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "mozaudioavailable",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
      ];

      const video = this.video;
      listenFor.forEach(function(value, index) {
        video.addEventListener(value, function(e: Event) {
          console.log(e);
        });
      });
    }
  }

  initialiseHLSMode(url: string) {
    if (Hls.isSupported()) {
      let hls = new Hls({
        // debug: this.debug,
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = false;
        }
      });
      hls.loadSource(url);
      hls.attachMedia(this.video);
      hls.on(Hls.Events.MANIFEST_LOADED, (event, data) => {
        if (data.url) {
          this.manifestURL = data.url;
        }
      });
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.video.play();
      });

      let adCount = 0;
      hls.on(Hls.Events.FRAG_PARSING_METADATA, (event, data) => {
        let string = "";
        let pts = 0;

        for (let elem of data.samples) {
          pts = elem.pts;
          let uint8array = elem.data;
          string = string + new TextDecoder("utf-8").decode(uint8array) + "\n";
        }

        if (this.debug) {
          console.log("Hls.Events.FRAG_PARSING_METADATA");
          console.log(data);

          console.log(string);
        }
        this.adease.notifyID3Event(string, pts * 1000).then(() => {
          if (this.adease.getAds().length > adCount) {
            adCount = this.adease.getAds().length;

            const extractIdentifier = tag => {
              var parts = tag.split(":");
              return parts[1].trim();
            };

            let owner = "switch.tv";
            let tag = string;
            let ownerPosition = tag.indexOf(owner);

            if (ownerPosition !== -1) {
              tag = string.slice(ownerPosition + owner.length);
              if (tag.indexOf("CUE:") !== -1) {
              } else if (tag.indexOf("ADSTART:") !== -1) {
                let id = extractIdentifier(tag);
                this.attachAdDataHandler(id);
              } else if (tag.indexOf("ADEND:") !== -1) {
              }
            }
          }
        });
        // this.adStatus.pushTag(string, pts);
      });
    }
  }

  sendAdInjectionSignal(duration: number): Promise<Response> {
    const formattedDuration = _.toString(_.round(duration / 1000));

    return fetch(
      this.elementalHost +
        "/adease/encode/282/cuepoint?token=YeTFI64LOMPpoketoPSmTt52SRSiD2qn",
      {
        method: "POST",
        body: JSON.stringify({
          duration: duration
        })
      }
    );
  }

  getElementalImage(): Promise<Response> {
    return fetch(this.elementalHost + "/adease/encode/282/thumbs");
  }

  adBreakRequested() {
    this.mergeState({
      waitingForAd: true
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.root}>
        <CssBaseline />

        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <img className={classes.logoImage} src={logo} alt="adease logo" />
            <Typography variant="title" color="inherit">
              Adease Live
            </Typography>
          </Toolbar>
        </AppBar>

        <Grid item xs={12} md={6} className={classes.gridLeft}>
          <Card>
            <CardMedia>
              <video autoPlay controls ref={this.videoElementAdded} />
            </CardMedia>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} className={classes.gridRight}>
          <AdInject
            useImage={this.useImage}
            sendAdInjectionSignal={this.sendAdInjectionSignal}
            getElementalImage={this.getElementalImage}
            adBreakRequested={this.adBreakRequested}
          />

          <AdInfo
            adDuration={this.state.adInfo.adDuration}
            adVendor={this.state.adInfo.adVendor}
          />

          <Beaconing
            showCount={true}
            beacons={this.state.beacons}
            waitingForAd={this.state.waitingForAd}
          />
        </Grid>

        <AppBar className={classes.footer} component="footer">
          <Toolbar className={classes.toolbarFooter}>
            <Typography color="inherit">
              Powered by <img className={classes.footerLogo} src={logo} />
            </Typography>
            <Typography color="inherit">
              © Copyright 2018 Switch Media. All rights reserved
            </Typography>
          </Toolbar>
      </AppBar>
      </Grid>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/Live/App.js